type ExtendedWindow = typeof window & { env: typeof process.env; };
export const env = (process.env.NODE_ENV == 'production') ? (window as ExtendedWindow).env : process.env;
